
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Angulartics2 } from 'angulartics2';

import { BarraProgressoService } from './../_shared/barra-progresso/barra-progresso.service';
import { SessionService } from './../_shared/session/session.service';
import { AlertsService } from './../_shared/alerts/alerts.service';


@Injectable()
export class StepGuard implements CanActivate {

  constructor(private router: Router,
    private barraProgressoService: BarraProgressoService,
    private SessionService: SessionService,
    private AlertsService: AlertsService,
    private angulartics2: Angulartics2,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    this.AlertsService.removeAlertas();

    const passoAtual: string = this.SessionService.getValor('passoAtual');
    // if (passoAtual >= route.data.passo) {
    this.SessionService.setValor('passoAtual', route.data.passo);
    this.barraProgressoService.atualizaProgresso(route.data.passo);

    // faz a chamada do analytics

    //Início Ch 557636 - Rafael dos Santos - 13/06/2024
    let url = this.router.url;
    let urlTratada = url.replace(/-\d+-\d+-\b[a-zA-Z]{1,2}\b-\d{4}-\d{1}(-\w+)?$/, '-InscricaoMatricula'); //Remove os números e 'InscricaoMatricula' da url, para que o Analytic consiga fazer a leitura
    let regexTeste = /-InscricaoMatricula$/

    //Força inclusão da -InscricaoMatricula caso ainda não esteja
    if (!regexTeste.test(urlTratada)){
      urlTratada += '-InscricaoMatricula'
    }

    //Fim Ch 557636 - Rafael dos Santos - 13/06/2024
    this.angulartics2.eventTrack.next({ action: 'trocaPasso', properties: { category: urlTratada } }); //Substituído o this.router.url por uma variável tratada, para que o analytics consiga ser acionado normalmente //Ch 557636 - Rafael dos Santos - 13/06/2024
    return true;
    // }

    // return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/_guards/step.guard.ts